export const LogoutTranslationsDictionary = {
    Logout: "Logout",
    LoggingOut: "Logging out...",
    LogoutTakingLonger: "We're having some trouble logging you out. Please wait or try again later.",
    CannotLogoutOffline: "Cannot log out due to limited or no internet connection. Try again later.",
    DisconnectedLogoutUnavailable: "Disconnected: Logout Unavailable",
    OK: "OK",
    Cancel: "Cancel"
};

let getTranslations = () => {
    let r: string[] = [];
    for (const prop in LogoutTranslationsDictionary) {
        r.push(LogoutTranslationsDictionary[prop]);
    }
    return r;
};

export const LogoutTranslations = getTranslations();
